import { cva } from 'class-variance-authority';

export const cvaAddParkingPageTitle = cva([
  'AddParkingPageStyles-cvaAddParkingPageTitle',
  'text-[2.4rem] text-cWhite font-extrabold',
  'mt-1',
]);

export const cvaAddParkingPageLabel = cva([
  'AddParkingPageStyles-cvaAddParkingPageLabel',
  'block',
  'mb-0.4',
  'text-m-sb text-cGray',
]);

export const cvaAddParkingPageText = cva([
  'AddParkingPageStyles-cvaAddParkingPageText',
  'block',
  'ml-3.6 mt-0.8',
  'text-m-sb text-cGray',
]);

export const cvaAddParkingPageLink = cva([
  'AddParkingPageStyles-cvaAddParkingPageLink',
  'block',
  'ml-3.6 mt-0.8',
  'text-m-sb text-cGreen',
]);
